"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Orderbooks = exports.Orderbook = void 0;
class Orderbook {
    constructor() {
        this.bids = [];
        this.asks = [];
        this.isLoaded = false;
    }
}
exports.Orderbook = Orderbook;
class Orderbooks {
    constructor() {
        this.list = {};
    }
}
exports.Orderbooks = Orderbooks;
//# sourceMappingURL=orderbook.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/exchange-common/models/orderbook.js
// module id = 199
// module chunks = 0